import React from "react";
import { formItems } from "../../../shared/informationRequest/informationRequestConfiguration";
import RenderQuestion from "../utils/RenderQuestion";

// form must come from useDynamicFormDoable, which adds handleUploadInProgress. renderAfter, given an
// item's identifier, returns anything to show straight after that item.
const FormQuestions = ({ configuration, form, caseRef, doableId, renderAfter }) => {
  const {
    responses,
    documentUploads,
    errors,
    errorMessages,
    handleInputChange,
    handleUploadsChanged,
    handleUploadFailuresChanged,
    handleUploadInProgress,
    handleCheckboxChange,
    handleDateChange,
    handleFieldValidation,
    handleDateFieldValidation,
    fieldRefs,
  } = form;
  const { fieldsByIdentifier, itemIdentifiers } = formItems(configuration);

  return itemIdentifiers.map((name) => {
    const fieldConfig = fieldsByIdentifier.get(name);
    // Always a keyed fragment: switching between it and a bare div when renderAfter starts
    // returning something would remount the question and drop its focus
    return (
      <React.Fragment key={name}>
        <div ref={(el) => (fieldRefs.current[name] = el)}>
          <RenderQuestion
            doableConfig={configuration}
            fieldConfig={fieldConfig}
            responses={responses}
            selected={responses[name]}
            value={responses[name] || ""}
            onChange={handleCheckboxChange(name)}
            onDateChange={handleDateChange(name)}
            optionSelected={handleInputChange(name)}
            uploads={documentUploads[name]}
            onUploadsChanged={handleUploadsChanged(name)}
            onUploadFailuresChanged={handleUploadFailuresChanged(name)}
            onUploadInProgress={handleUploadInProgress(name)}
            caseRef={caseRef}
            doableId={doableId}
            validate={handleFieldValidation(name)(fieldConfig.field_type)}
            validateDate={handleDateFieldValidation(name)}
            hasValidationError={!!errors[name]}
            validationErrorMessage={errorMessages[name]}
          />
        </div>
        {renderAfter?.(name)}
      </React.Fragment>
    );
  });
};

export default FormQuestions;
